export default "__VITE_ASSET__BrKmOtlw__"